<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-row>
            <v-col class="ml-3">
              <v-card class="pa-4">
                <v-text-field
                  v-model="requiredCheckingEmployeeSearchInput"
                  placeholder="Filter employee by name"
                  append-icon="search"
                  label="Search Employee"
                  hide-no-data
                  hide-selected
                />
                <v-autocomplete
                  v-model="requireCheckingPositions"
                  :items="positions"
                  item-text="name"
                  item-value="id"
                  value="id"
                  label="Position"
                  placeholder="Filter employee by position"
                  clearable
                  hide-selected
                  multiple
                  chips
                  deletable-chips
                />
                <h4 class="font-weight-bold">
                  Employee Required Location Checking:
                </h4>
                <v-data-table
                  v-model="disableCheckingEmployeeList"
                  :loading="tableLoading"
                  :headers="headers"
                  dense
                  :items="filteredRequiredCheckingEmployees"
                  hide-default-footer
                  fixed-header
                  disable-pagination
                  class="elevation-1 mb-3"
                  show-select
                  item-key="user.name"
                  item-value="employee_uid"
                  height="380px"
                >
                  <template v-slot:item.require_location_checking="{ item }">
                    <v-icon
                      v-if="item.require_location_checking === 1"
                      color="success"
                    >
                      mdi-checkbox-marked-circle
                    </v-icon>
                    <v-icon
                      v-else
                      color="error"
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                </v-data-table>
                
                <v-card-actions class="mx-0">
                  <v-spacer />
                  <v-btn
                    color="success"
                    :loading="disableLocationCheckingButtonLoading"
                    @click="disableLocationChecking"
                  > 
                    Disable Location Checking
                    <v-icon class="pl-1">
                      mdi-arrow-right-bold-circle-outline
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="1"
              class="d-flex justify-center"
            >
              <v-icon large>
                mdi-repeat
              </v-icon>
            </v-col>
            <v-col class="mr-3">
              <v-card class="pa-4">
                <v-text-field
                  v-model="notRequiredCheckingEmployeeSearchInput"
                  placeholder="Filter employee by name"
                  append-icon="search"
                  label="Search Employee"
                  hide-no-data
                  hide-selected
                />
                <v-autocomplete
                  v-model="notRequireCheckingPositions"
                  :items="positions"
                  item-text="name"
                  item-value="id"
                  value="id"
                  label="Position"
                  placeholder="Filter employee by position"
                  clearable
                  hide-selected
                  multiple
                  chips
                  deletable-chips
                />
                <h4 class="font-weight-bold">
                  Employee DOES NOT Required Location Checking:
                </h4>

                <v-data-table
                  v-model="enableCheckingEmployeeList"
                  :loading="tableLoading"
                  :headers="headers"
                  dense
                  :items="filteredNotRequiredCheckingEmployees"
                  hide-default-footer
                  fixed-header
                  disable-pagination
                  class="elevation-1 mb-3"
                  show-select
                  item-key="user.name"
                  item-value="employee_uid"
                  height="380px"
                >
                  <template v-slot:item.require_location_checking="{ item }">
                    <v-icon
                      v-if="item.require_location_checking === 1"
                      color="success"
                    >
                      mdi-checkbox-marked-circle
                    </v-icon>
                    <v-icon
                      v-else
                      color="error"
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                </v-data-table>

                <v-card-actions class="mx-0">
                  <v-btn
                    color="success"
                    :loading="enableLocationCheckingButtonLoading"
                    @click="enableLocationChecking"
                  >
                    <v-icon class="pr-1">
                      mdi-arrow-left-bold-circle-outline
                    </v-icon>Enable Location Checking
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        requiredCheckingEmployeeSearchInput: '', 
        notRequiredCheckingEmployeeSearchInput: '',
        positions: [],
        requireCheckingPositions: [],
        notRequireCheckingPositions: [],
        requiredCheckingEmployees: [],
        notRequiredCheckingEmployees: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'user.name',
          },
          {
            text: 'Position',
            align: 'left',
            sortable: true,
            value: 'current_position.position.name',
          },
          {
            text: 'Location Checking',
            align: 'center',
            sortable: false,
            value: 'require_location_checking',
          },        
        ],
        tableLoading: false,  
        enableCheckingEmployeeList: [],
        disableCheckingEmployeeList: [],
        enableLocationCheckingButtonLoading: false,
        disableLocationCheckingButtonLoading: false,
      }
    },

    computed: {
      filteredRequiredCheckingEmployees () {
        let _this = this
        _this.requiredCheckingEmployeeSearchInput = _this.requiredCheckingEmployeeSearchInput.trim()

        let primaryFilterEmployees = this.requiredCheckingEmployees.filter(function (employee) {
          return ((employee.user || {}).name || '').toLowerCase().indexOf(_this.requiredCheckingEmployeeSearchInput.toLowerCase()) !== -1 ||
            ((employee.user || {}).username || '').toLowerCase().indexOf(_this.requiredCheckingEmployeeSearchInput.toLowerCase()) !== -1
        })

        let filteredPositions = this.customFilterPositions(primaryFilterEmployees, _this.requireCheckingPositions)
        return filteredPositions
      },

      filteredNotRequiredCheckingEmployees () {
        let _this = this

        _this.notRequiredCheckingEmployeeSearchInput = _this.notRequiredCheckingEmployeeSearchInput.trim()

        let primaryFilterEmployees = this.notRequiredCheckingEmployees.filter(function (employee) {
          return ((employee.user || {}).name || '').toLowerCase().indexOf(_this.notRequiredCheckingEmployeeSearchInput.toLowerCase()) !== -1 ||
            ((employee.user || {}).username || '').toLowerCase().indexOf(_this.notRequiredCheckingEmployeeSearchInput.toLowerCase()) !== -1
        })
        let filteredPositions = this.customFilterPositions(primaryFilterEmployees, _this.notRequireCheckingPositions)
        return filteredPositions
      },
    },

    created () {
      this.loadEmployees()
      this.loadPositions()
    },

    methods: {
      loadPositions () {
        this.$api.positions().list()
          .then(response => {
            this.positions = response.data
          })
      },
      loadEmployees () {
        this.tableLoading = true

        Promise.all([
          this.$api.adminStateEmployees().list('?filter[require_location_checking]=1'),
          this.$api.adminStateEmployees().list('?filter[require_location_checking]=0'),
        ])
          .then(([requireCheckingEmployees, notRequireCheckingEmployees]) => {
            this.requiredCheckingEmployees = requireCheckingEmployees.data
            this.notRequiredCheckingEmployees = notRequireCheckingEmployees.data
            this.tableLoading = false
          })
      },

      customFilterPositions (employeesList, positionFilter) {
        if (positionFilter.length === 0) return employeesList

        return employeesList.filter(employee => {
          let positionId = (employee.current_position || {}).position_id

          return _.intersection([positionId], positionFilter).length > 0
        })
      },

      disableLocationChecking () {
        this.disableLocationCheckingButtonLoading = true
        this.$api.employeeAttendanceSettings().bulkUpdate(this.prepareFormData(this.disableCheckingEmployeeList, 0))
          .then(res => {
            this.loadEmployees()
            this.disableCheckingEmployeeList = []
            this.disableLocationCheckingButtonLoading = false
            this.$snack({
              message: 'Attendance setting updated successfully!',
            })
          })
      },

      enableLocationChecking () {
        this.enableLocationCheckingButtonLoading = true

        this.$api.employeeAttendanceSettings().bulkUpdate(this.prepareFormData(this.enableCheckingEmployeeList, 1))
          .then(res => {
            this.loadEmployees()
            this.enableCheckingEmployeeList = []
            this.enableLocationCheckingButtonLoading = false
            this.$snack({
              message: 'Attendance setting updated successfully!',
            })
          })
      },

      prepareFormData (employees, value) {
        let employeeUids = []

        employees.map(employee => {
          employeeUids.push(employee.employee_uid)
        })

        return {
          employees: employeeUids,
          require_location_checking: value,
        }
      },
    },
  }
</script>
